import type { SVGProps } from 'react';
export const IconKitSearchMap = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      width={48}
      height={48}
      rx={24}
      fill="#BB683C"
    />
    <path
      d="M22.875 30.75C27.2242 30.75 30.75 27.2242 30.75 22.875C30.75 18.5258 27.2242 15 22.875 15C18.5258 15 15 18.5258 15 22.875C15 27.2242 18.5258 30.75 22.875 30.75Z"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M28.4434 28.4438L32.9996 33.0001"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
